import { SxProps, Theme, alpha } from '@mui/material'

import { SearchBarVariant } from '.'

export const containerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  borderRadius: '0.4rem',
}

export const contentSx = ({
  variant,
}: {
  variant: SearchBarVariant
}): SxProps<Theme> => {
  const variantSx = {
    'landing-page': {
      height: '4.8rem',
    },
    catalog: {
      height: {
        xs: '4rem',
        md: '5.4rem',
      },
    },
    default: {
      height: '5.4rem',
    },
  }

  const height = variantSx[variant].height

  return {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    height,
    padding: '1.4rem',
    border: '1px solid',
    borderColor: (theme) => alpha(theme.palette.text.primary, 0.3),
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  }
}

export const embeddedSearchIconSx: SxProps<Theme> = {
  width: '2.4rem',
  height: '2.4rem',
}

export const searchIconSx: SxProps<Theme> = {
  color: 'text.secondary',
  width: '2.4rem',
  height: '2.4rem',
}

export const searchIconButtonSx: SxProps<Theme> = {
  marginRight: '-1.1rem',
}

export const clearSearchButtonSx: SxProps<Theme> = {
  marginRight: '-0.8rem',
}

export const clearSearchIconSx: SxProps<Theme> = {
  width: '2.4rem',
  height: '2.4rem',
  color: (theme) => theme.palette.text.secondary,
}

export const inputBaseSx = ({
  variant,
}: {
  variant: SearchBarVariant
}): SxProps<Theme> => {
  const variantSx = {
    'landing-page': {
      marginLeft: 0,
    },
    catalog: {
      marginLeft: 0,
    },
    default: {
      marginLeft: '1.2rem',
    },
  }

  const marginLeft = variantSx[variant].marginLeft

  return {
    textOverflow: 'ellipsis',
    flex: 1,
    letterSpacing: '0.03rem',
    marginLeft,
    '& input::placeholder': {
      color: 'text.primary',
      opacity: 0.6,
    },
  }
}

export const searchButtonSx: SxProps<Theme> = {
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  minHeight: '5.4rem',
  boxShadow: 2,
  padding: '0.6rem 2.4rem',
}

export const embeddedSearchButtonSx = ({
  variant,
}: {
  variant: SearchBarVariant
}): SxProps<Theme> => {
  const variantSx = {
    'landing-page': {},
    catalog: {
      minHeight: '4rem',
    },
    default: {},
  }

  return {
    ...searchButtonSx,
    padding: '0.6rem 1.4rem',
    marginRight: '-0.1rem',
    '& > span': {
      margin: 0,
    },
    ...variantSx[variant],
  }
}
